import React from "react";

const defaultBullets = [
  "Select the year for which data will be filled",
  "Set the reporting frequency (Monthly, Quarterly, Half Yearly, Yearly) for each form",
];

const UnlockProjectBeforeAssign = ({
  onOpen,
  onClose,
  handleSave,
  title = "Warning",
  message = "Please complete the project setup before assigning forms to users.",
  bullets = defaultBullets,
}) => {
  if (!onOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        zIndex: 9999,
      }}
    >
      <div className="bg-white rounded-lg overflow-hidden shadow-xl max-w-sm w-full mx-4">
        <div className="bg-[#FFC107] text-white text-center py-3">
          <h3 className="font-semibold text-base">{title}</h3>
        </div>

        <div className="px-6 py-6 text-center">
          <div className="mb-4">
            <div className="w-12 h-12 bg-[#FFC107] rounded-full flex items-center justify-center mx-auto">
              <svg
                className="w-6 h-6 text-white"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                  clipRule="evenodd"
                />
              </svg>
            </div>
          </div>

          <div className="mb-6">
            <p className="text-gray-800 text-sm leading-relaxed font-medium mb-3">
              {message}
            </p>
          </div>

          <div className="flex justify-center gap-3">
            <button
              onClick={onClose}
              className="px-1 py-2 w-40 border border-[#06513D] text-[#06513D] rounded-md hover:bg-gray-50 transition-colors duration-200 font-light text-sm"
            >
              Cancel
            </button>
            <button
              onClick={handleSave}
              className="px-1 w-40 py-2 bg-[#06513D] text-white rounded-md hover:bg-[#054a36] transition-colors duration-200 font-light text-sm"
            >
              Go to Project Setup
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnlockProjectBeforeAssign;
